export enum DocsVerificationSideEnum {
    BACK = 'back',
    FRONT = 'front',
    MAIN = 'main',
}
